export enum ActionTypeFilter {
   SET_TAG = 'setTag',
   SET_CATEGORY = 'setCategory',
   SET_COLOR = 'setColor',
   SET_OFFER = 'setOffer',
   SET_ORDER = 'setOrder',
   SET_PRICE = 'setPrice',
   RESET_FILTER = 'resetFilters'
}